import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

/**
 * Pushes a `page_view` to the dataLayer on every route change (and on first
 * paint) so GTM can fire GA4/HubSpot/ads page views for this SPA. Waits a tick
 * for react-helmet to update <title> so page_title is the new page's title.
 */
export default function GtmRouteTracker() {
  const { pathname, search } = useLocation();
  const last = useRef(null);
  useEffect(() => {
    const path = pathname + search;
    if (last.current === path) return undefined;
    last.current = path;
    const t = setTimeout(() => trackPageView({ path, title: document.title }), 250);
    return () => clearTimeout(t);
  }, [pathname, search]);
  return null;
}
